import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@components/common/Layout';

const MenuSelect = props => {
    const {
        menuInfo,
        visible,
        setVisible
    } = props;

    return (visible && (
            <>
            <div className="table-wrap-reg">
                <div className="round-box">
                    <div className="tit-area">
                        <h3>선택한 메뉴정보</h3>
                    </div>
                    <div className="">
                        <table className="tbl-sty2">
                            <colgroup>
                                <col width="20%;" />
                                <col width="80%;" />
                            </colgroup>
                            <tbody> 
                                <tr>
                                    <th>메뉴ID</th>
                                    <td>{$utils.convertToHtml(menuInfo.menuId)}</td>
                                </tr>
                                <tr>
                                    <th>메뉴명</th>
                                    <td>{$utils.convertToHtml(menuInfo.menuNm)}</td>
                                </tr>
                                <tr>
                                    <th>메뉴depth</th>
                                    <td>{menuInfo.depth}depth</td>
                                </tr>
                                <tr>
                                    <th>메뉴순서</th>
                                    <td>{menuInfo.menuSortOrd}</td>
                                </tr>
                                <tr>
                                    <th>화면유형</th>
                                    <td>{menuInfo.aplctnScrenTyCd === "01" ? ('메뉴그룹'):(menuInfo.aplctnScrenTyCd === "02" ? ('메인'):('팝업'))}</td>
                                </tr>
                                <tr>
                                    <th>표시여부</th>
                                    <td>{menuInfo.useYn === "Y" ? ('표시'):('미표시')}</td>
                                </tr>
                                <tr>
                                    <th>외부사용여부</th>
                                    <td>{menuInfo.extNtwkUseYn === "Y" ? ('사용'):('미사용')}</td>
                                </tr>
                                <tr>
                                    <th>링크메뉴여부</th>
                                    <td>{menuInfo.linkMenuYn === "Y" ? ('사용'):('미사용')}</td>
                                </tr>
                                <tr>
                                    <th>링크URL</th>
                                    <td>                                        
                                        {menuInfo.linkUrlAddr === null ? ('없음'):(<a href={menuInfo.linkUrlAddr} target="_blank" >{$utils.convertToHtml(menuInfo.linkUrlAddr)}</a>)}
                                     </td>
                                </tr>
                                <tr>
                                    <th>SSO연동여부</th>
                                    <td>{menuInfo.ssoLinkdYn === "Y" ? ('사용'):('미사용')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
          </>
        )        
    );
};

export default MenuSelect;